import * as React from 'react';
import { Cite } from './Pullquote.styles.js';
import Typography from '../Typography/index.js';

var Pullquote = function Pullquote(_ref) {
  var children = _ref.children,
    _ref$cite = _ref.cite,
    cite = _ref$cite === void 0 ? '' : _ref$cite;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    rendersAs: "blockquote",
    className: "leshen-pullquote"
  }, children), cite && /*#__PURE__*/React.createElement(Cite, {
    variant: "feature",
    rendersAs: "span",
    className: "cite"
  }, cite));
};
var Pullquote$1 = Pullquote;

export { Pullquote$1 as default };
//# sourceMappingURL=index.js.map
